import React from "react";
import { connect } from "react-redux";
import { QuestionContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { MdAdd, MdAssignmentAdd } from "react-icons/md";
import momentTZ from "moment-timezone";
import queryString from "query-string";
import { RenderCommaMoney } from "utils/functions/FormatMoney";
import { Buttons, Inputs, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class QuestionContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_QUESTION_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.QUESTION}/${e}`);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.QUESTION}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleClickQuestionViewDetail = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.QUESTION}/detail/${e}`);
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "question");
    return (
      <QuestionContainerStyled>
        {permission && permission.is_create && (
          <div className="btn_create">
            <div className="w120">
              <Buttons.BgIconPrefix
                label="New"
                icon={<MdAdd size={18} />}
                onClick={() => this.handleClickCreate("create")}
              />
            </div>
          </div>
        )}
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table  ">
              <Tables.Standard
                columns={columns({
                  handleClickDetail: this.handleClickCreate,
                  handleClickQuestionViewDetail:
                    this.handleClickQuestionViewDetail,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </QuestionContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "title",
      length: "311px",
      filter: {
        fieldQuery: "title",
        defaultValue: initialValues["title"],
        type: "text",
        label: "Name search",
        placeholder: "name",
      },
    },
  ];
};

const columns = ({ handleClickDetail, handleClickQuestionViewDetail }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Name</div>,
    accessor: "title",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>คะแนน</div>,
    accessor: "point",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RenderCommaMoney(props.value, true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Active</div>,
    accessor: "is_active",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value ? (
          <Displays.StatusLabel bg={"green"} label={"ทำงาน"} />
        ) : (
          <Displays.StatusLabel bg={"#FFB341CC"} label={"ไม่ทำงาน"} />
        )}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Action</div>,
    accessor: "action",
    Cell: (props) => (
      <div
        onClick={() => handleClickQuestionViewDetail(props.row.original._id)}
      >
        <MdAssignmentAdd size={22} color="#4b1e78" />
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(QuestionContainer));
